export default "__VITE_ASSET__b176a5a8__"